/**
 * 「押すと確認ダイアログが出るボタン」。
 *
 * 破壊的操作はすべて確認を通す規約なので、一覧の行アクションのように
 * 数が多い場所で毎回 open state を書かなくて済むようにまとめる。
 * 重度の操作（メールが消える）は `<ConfirmTextDialog>` を使うこと。
 */
import * as React from 'react';
import { Button, ConfirmDialog, type ButtonProps } from '@mail-sv/ui';

export function ConfirmDialogButton({
  title,
  description,
  confirmLabel = '実行する',
  onConfirm,
  pending = false,
  destructive = true,
  variant = 'ghost',
  size = 'sm',
  children,
  disabled,
}: {
  title: React.ReactNode;
  description?: React.ReactNode;
  confirmLabel?: string;
  onConfirm: () => void;
  pending?: boolean;
  destructive?: boolean;
  variant?: ButtonProps['variant'];
  size?: ButtonProps['size'];
  children: React.ReactNode;
  disabled?: boolean;
}) {
  const [open, setOpen] = React.useState(false);

  return (
    <>
      <Button type="button" variant={variant} size={size} onClick={() => setOpen(true)} disabled={disabled}>
        {children}
      </Button>
      <ConfirmDialog
        open={open}
        onOpenChange={(next) => {
          // 実行中に閉じられると、結果が分からないまま残る。
          if (pending) return;
          setOpen(next);
        }}
        title={title}
        description={description}
        confirmLabel={confirmLabel}
        destructive={destructive}
        loading={pending}
        onConfirm={() => {
          onConfirm();
          setOpen(false);
        }}
      />
    </>
  );
}
